/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: scorecard.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  BackfillScorecardMetadataKeysRequest,
  BackfillScorecardMetadataKeysResponse,
  CreateScorecardRequest,
  CreateScorecardResponse,
  DeleteScorecardRequest,
  DeleteScorecardResponse,
  GetScorecardRequest,
  GetScorecardResponse,
  ListScorecardsRequest,
  ListScorecardsResponse,
  UpdateScorecardRequest,
  UpdateScorecardResponse,
} from '../types/scorecard';

export const createScorecardService = (transport: Transport) => ({
  async createScorecard(
    request: CreateScorecardRequest,
    options: RequestOptions = {},
  ): Promise<CreateScorecardResponse> {
    const { organization_id, program_id, ...body } = request;
    const url = getApiPath(API_METHODS.ScorecardService.CreateScorecard, {
      organization_id,
      program_id,
    });
    return transport.post<CreateScorecardResponse>(url, body, options);
  },

  async getScorecard(
    request: GetScorecardRequest,
    options: RequestOptions = {},
  ): Promise<GetScorecardResponse> {
    const { organization_id, program_id, scorecard_id } = request;
    const url = getApiPath(API_METHODS.ScorecardService.GetScorecard, {
      organization_id,
      program_id,
      scorecard_id,
    });
    return transport.get<GetScorecardResponse>(url, options);
  },

  async listScorecards(
    request: ListScorecardsRequest,
    options: RequestOptions = {},
  ): Promise<ListScorecardsResponse> {
    const { organization_id, program_id, ...params } = request;
    const url = getApiPath(API_METHODS.ScorecardService.ListScorecards, {
      organization_id,
      program_id,
    });
    return transport.get<ListScorecardsResponse>(url, { params, ...options });
  },

  async updateScorecard(
    request: UpdateScorecardRequest,
    options: RequestOptions = {},
  ): Promise<UpdateScorecardResponse> {
    const { organization_id, program_id, scorecard_id, ...body } = request;
    const url = getApiPath(API_METHODS.ScorecardService.UpdateScorecard, {
      organization_id,
      program_id,
      scorecard_id,
    });
    return transport.post<UpdateScorecardResponse>(url, body, options);
  },

  async deleteScorecard(
    request: DeleteScorecardRequest,
    options: RequestOptions = {},
  ): Promise<DeleteScorecardResponse> {
    const { organization_id, program_id, scorecard_id } = request;
    const url = getApiPath(API_METHODS.ScorecardService.DeleteScorecard, {
      organization_id,
      program_id,
      scorecard_id,
    });
    return transport.delete<DeleteScorecardResponse>(url, options);
  },

  async backfillScorecardMetadataKeys(
    request: BackfillScorecardMetadataKeysRequest,
    options: RequestOptions = {},
  ): Promise<BackfillScorecardMetadataKeysResponse> {
    const { organization_id, program_id, ...body } = request;
    const url = getApiPath(API_METHODS.ScorecardService.BackfillScorecardMetadataKeys, {
      organization_id,
      program_id,
    });
    return transport.post<BackfillScorecardMetadataKeysResponse>(url, body, options);
  },
});

export type ScorecardService = ReturnType<typeof createScorecardService>;
